import React, { useContext, useEffect, useState } from 'react';
import "./FirstTimeChecker.scss";
import KITCHEN_PNG from "../../global/assets/png/Kitchen-FirstTimeChecker.png"
import { StoreHeaderDataContext } from '../../context-api/StoreHeaderDataProvider';
import ZipCodeForm from '../../atomic/zipcodechecker/web/zipcodeform/ZipCodeForm';
import variables from "../../global/assets/_variables.scss";
import { DataContext } from '../../context-api/DataProvider';
import NO_SERVICE_ANIMATION from "../../global/assets/animation/no_service_available.json";
import EMAIL_SEND_PNG from "../../global/assets/png/mail@2x.png";
import Lottie from 'lottie-react';
import { MEDIUM_SCREEN, screenSize } from '../../global/ScreenSizeHelper';
import InputBox from '../../atomic/inputbox/InputBox';
import { emailRegex } from '../../global/constants';
import AtomicButton from '../../atomic/button/AtomicButton';
import { InputAdornment } from '@mui/material';
import { Mail } from '@mui/icons-material';

const buttonStyleProp = {
  width: "fit-content",
  height: "55px",
  padding: "6px",
  fontSize: "12px",
  lineHeight: "initial",
  maxWidth: "200px",
  flexGrow: 1,
  flexShrink: 1,
};
const zipCodeFormContainerStyle = {
  display: "flex",
  flexDirection: "column",
  paddingRight: "55px",
  paddingTop: "10px",
  maxWidth: "500px"
};
const inputStyles = {
  height: "55px",
  flexGrow: 1,
  flexShrink: 1,
  background: "white"
};

const submitButtonStyle = {
  marginLeft: "10px",
  background: variables.backgroundDarkBlue,
  width: "128px",
  height: "56px"
}

const enterNewZipcodeButtonStyle = {
  background: variables.backGroundLightBlue,
  width: "207px",
  height: "45px"
}

export const FirstTimeCheckerDesktop = () => {
  const isMediumScreen = screenSize === MEDIUM_SCREEN;
  const [email, setEmail] = useState("");
  const [enteredZipcode, setEnteredZipcode] = useState("");
  const [isEmailFormatValid, setEmailFormatValid] = useState(true);
  const { kitchensByZipcode, zipcode, clearZipcodeFromLocalStorage, setIsDeliverable } = useContext(StoreHeaderDataContext) || {};
  const { data, loading, success, totalKitchens } = kitchensByZipcode;
  const {
    createFutureCustomerData,
    setCreateFutureCustomerData,
    onCreateFutureCustomer,
  } = useContext(DataContext);

  const handleEmailChange = (e) => {
    const emailInput = e.target.value;
    const isEmailValid = emailRegex.test(emailInput);
    setEmailFormatValid(isEmailValid);
    setEmail(emailInput);
  };

  const onEmailSubmit = () => {
    onCreateFutureCustomer({
      email,
      zipcode: zipcode || enteredZipcode,
      manual_notes: "firstTimeServiceChecker",
    });
  };

  const onEnterNewZipcode = () => {
    clearZipcodeFromLocalStorage()
  }

  useEffect(() => {
    if (zipcode) {
      setEnteredZipcode(zipcode)
    }
  }, [zipcode]);

  useEffect(() => {
    if (success) {
      setEmail("");
      setCreateFutureCustomerData({
        ...createFutureCustomerData,
        success: false,
      });
    }
    if (totalKitchens > 0) {
      setIsDeliverable(true);
    }
  }, [success, totalKitchens]);


  return (
    <div className="firstime-checker">
      <div className="first-time-service-checker-container">
        {success ?
          <>
            <div className="title">You want it. We get it.</div>
            <div className="sub-title">
              Discover Delicious & Affordable Combo Meals Nearby
            </div>
            <div className="zipcode-label">
              Enter USA Zipcode
            </div>
            <div className="zipcode-entry-form">
              <ZipCodeForm
                size="large"
                buttonStyleProp={buttonStyleProp}
                buttonBackground={variables.backgroundDarkBlue}
                zipCodeFormContainerStyle={zipCodeFormContainerStyle}
                inputStyles={inputStyles}
                data={data}
                loading={loading}
                success={success}
                buttonLabel="Find Food"
                hideIcon={true}
              />
            </div>
          </>
          :
          <>
            <div className="title">We're not there yet!</div>
            <div className="no-kitchen-info-msg">
              Service unavailable in your area at the moment – but we’re coming soon!
            </div>
          </>
        }

        {!success && !createFutureCustomerData.success && (
          <div className="email-form">
            <div className="email-form-title">
              Grab Your $50 Discount Now
            </div>
            <div className="email-form-coupon">Coming Soon Near You – Claim Your $50 Savings Today!</div>
            <div className="email-button-container">
              <InputBox
                label="Enter Email"
                type="email"
                size="medium"
                width="100%"
                height="auto"
                sx={{ marginTop: "15px", background: "white" }}
                name="email"
                value={email}
                onChange={handleEmailChange}
                inputErrorMsg={isEmailFormatValid ? "" : "Invalid email format"}
                error={!isEmailFormatValid}
                inputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>
                      <Mail />
                    </InputAdornment>
                  )
                }}
              />
              <AtomicButton
                label="SUBMIT"
                style={submitButtonStyle}
                loadingButtonStyle={{ ...submitButtonStyle, background: variables.backgroundDisabled }}
                disabled={!isEmailFormatValid}
                handleSubmit={onEmailSubmit}
              />
            </div>
          </div>
        )}

        {!success && createFutureCustomerData.success && (
          <div className="thank-you-box">
            <img
              className="eat_img"
              src={EMAIL_SEND_PNG}
              alt="Thank Email Sent"
            />
            <div className="thank-you-content">
              <span className="thanks-msg1">Thank you</span>
              <span className="thanks-msg2">We’ll send your discount coupon shortly.</span>
            </div>
          </div>
        )}
        {!success && <AtomicButton
          label="Enter new Zipcode"
          style={enterNewZipcodeButtonStyle}
          handleSubmit={onEnterNewZipcode}
        />}
      </div>
      {!isMediumScreen && <div className="info-container">
        {success ?
          <>
            <div>Cloud Kitchen</div>
            <img src={KITCHEN_PNG}></img>
            <div className="chefs-text">Top Chefs are invited from around the globe to cook for your neighborhood</div>
          </>
          :
          <>
            <div>Sorry, no kitchen found</div>
            <Lottie
              animationData={NO_SERVICE_ANIMATION}
              loop={true}
            />
          </>
        }
      </div>}
    </div>
  )
}
